/**
 * Admin Portal – standalone application entry.
 * Run: npm run dev (opens at http://localhost:5177/)
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { Routes, Route } from "react-router-dom";
import { initSentry } from "@kivunova/kivufrontendcommon";
import AppProviders from "./AppProviders";
import App from "./App";
import WelcomePage from "./components/Welcome/WelcomePage";
import "./app.css";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";

try {
  initSentry();
} catch {
  // ignore Sentry init failure
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  document.body.innerHTML =
    "<p style='padding:20px;font-family:sans-serif;color:#c62828'>Root element not found.</p>";
} else {
  try {
    ReactDOM.createRoot(rootEl).render(
      <ErrorBoundary>
        <AppProviders wrapWithRouter={true}>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </AppProviders>
      </ErrorBoundary>,
    );
  } catch (err) {
    rootEl.innerHTML = [
      "<div style='padding:24px;font-family:sans-serif;max-width:560px'>",
      "<h2 style='color:#c62828'>Failed to start</h2>",
      "<p style='color:#666'>" +
        (err instanceof Error ? err.message : String(err)) +
        "</p>",
      '<button onclick="location.reload()">Reload</button>',
      "</div>",
    ].join("");
    console.error("Admin portal render error:", err);
  }
}
